import React from "react";
import { DatabaseZap, RefreshCw, SearchX } from "lucide-react";

// Small additive state for existing screens; it deliberately uses the existing
// terminal panel language rather than replacing any page layout.
export const DataState = ({ title = "Data temporarily unavailable", detail = "LONGVIEW couldn't reach the latest verified data. Please try again shortly.", onRetry }) => (
  <div data-testid="error-state" className="lv-fade-up flex min-h-56 flex-col items-center justify-center rounded-lg border border-indigo-500/20 bg-[#0B0C0E] px-6 py-10 text-center">
    <DatabaseZap className="h-6 w-6 text-indigo-300" />
    <p className="mt-3 text-sm font-medium text-zinc-200">{title}</p>
    <p className="mt-1 max-w-md text-xs leading-relaxed text-zinc-500">{detail}</p>
    {onRetry && (
      <button data-testid="error-state-retry-btn" onClick={onRetry} className="lv-press mt-4 inline-flex items-center gap-1.5 rounded-md border border-white/10 px-3 py-1.5 font-mono text-[11px] text-zinc-400 hover:border-white/20 hover:text-zinc-200">
        <RefreshCw className="h-3 w-3" /> Retry
      </button>
    )}
  </div>
);

// Alias for semantic clarity when used explicitly as an error boundary state.
export const ErrorState = DataState;

// Elegant, informative empty state for "no results" scenarios (filters,
// search, empty lists) — distinct from a hard error.
export const EmptyState = ({ icon: Icon = SearchX, title = "Nothing here yet", detail, action, className = "" }) => (
  <div data-testid="empty-state" className={`lv-fade-up flex min-h-56 flex-col items-center justify-center rounded-lg border border-white/[0.07] bg-[#0B0C0E] px-6 py-16 text-center ${className}`}>
    <Icon className="h-7 w-7 text-zinc-600" strokeWidth={1.5} />
    <p className="mt-3 text-sm font-medium text-zinc-300">{title}</p>
    {detail && <p className="mt-1 max-w-md text-xs leading-relaxed text-zinc-500">{detail}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
